export default __webpack_public_path__ + "static/media/Blade's Straps of the Grim Cabal.c4d9cc8c.jpg";